const TEXT = {
    ORDERS_CONTENT_TEXT_1:"我的订单",
    ORDERS_CONTENT_TEXT_2:"暂无订单",
    ORDERS_CONTENT_TEXT_3:"去逛逛",
    ORDERS_CONTENT_TEXT_4:"订单编号",
    ORDERS_CONTENT_TEXT_5:"实",
    ORDERS_CONTENT_TEXT_6:"待处理",
    ORDERS_CONTENT_TEXT_7:"待确认",
    ORDERS_CONTENT_TEXT_8:"待发货",
    ORDERS_CONTENT_TEXT_9:"待收货",
    ORDERS_CONTENT_TEXT_10:"交易成功",
    ORDERS_CONTENT_TEXT_11:"交易取消",
    ORDERS_CONTENT_TEXT_12:"共",
    ORDERS_CONTENT_TEXT_13:"件商品 合计",
    ORDERS_CONTENT_TEXT_14:"含运费",
    ORDERS_CONTENT_TEXT_15:"确认收货",
    ORDERS_CONTENT_TEXT_16:"查看详情",
    ORDERS_CONTENT_TEXT_17:"没有更多了",
    ORDERS_CONTENT_TEXT_18:"下级订单",
    ORDERS_CONTENT_TEXT_19:"订单详情",
    ORDERS_CONTENT_TEXT_20:"收货人",
    ORDERS_CONTENT_TEXT_21:"商家名称",
    ORDERS_CONTENT_TEXT_22:"商品总价",
    ORDERS_CONTENT_TEXT_23:"运费",
    ORDERS_CONTENT_TEXT_24:"实付款",
    ORDERS_CONTENT_TEXT_25:"买家留言",
    ORDERS_CONTENT_TEXT_26:"支付方式",
    ORDERS_CONTENT_TEXT_27:"现金",
    ORDERS_CONTENT_TEXT_28:"余额",
    ORDERS_CONTENT_TEXT_29:"创建时间",
    ORDERS_CONTENT_TEXT_30:"复制",
    ORDERS_CONTENT_TEXT_31:"内购订单",
    ORDERS_CONTENT_TEXT_32:"代理商姓名",
    orderStates: [
        {
          id: "-1",
          name: "全部"
        },
        {
          id: "0",
          name: "待处理"
        },
        {
          id: "1",
          name: "待确认"
        },
        {
          id: "2",
          name: "待发货"
        },
        {
          id: "3",
          name: "待收货"
        }
      ],
};
export {
	TEXT
}


// WEBPACK FOOTER //
// ./src/config/page/cn/orders/index.js